import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageSwitch } from '@/hooks/useLanguage';
import { useSiteImage } from '@/hooks/useSiteImage';

export default function StepProtectSection() {
  const { t } = useTranslation();
  const { currentLang } = useLanguageSwitch();
  const prefix = currentLang === 'ko' ? '/ko' : currentLang === 'bn' ? '/bn' : '';
  const imageUrl = useSiteImage('threeStep.step03.image', 'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/75d6b879-e15a-4d5f-a2a7-c13befb0ace6_Sample_Real_Serum_Creambox.png');

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative rounded-2xl overflow-hidden h-80 md:h-[480px] bg-[#F0EFED]">
            <img
              src={imageUrl}
              alt="Barrier Seal Cream — Step 03 LOCK"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-[#2D6A4F] text-white text-sm font-bold flex items-center justify-center">03</span>
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#2D6A4F] font-medium">{t('threeStep.step03.badge')}</span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2A2A2A] leading-[1.15]">{t('threeStep.step03.name')}</h2>

            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-[#2A2A2A]">{t('threeStep.step03.price')}</span>
              <span className="text-xs text-[#8A8A8A] font-light">{t('threeStep.step03.volume')}</span>
            </div>

            <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
              {t('threeStep.step03.desc')}
            </p>

            <div className="flex flex-col gap-3">
              <span className="text-[11px] tracking-[0.15em] uppercase text-[#2A2A2A] font-medium">{t('threeStep.step03.ingredientsLabel')}</span>
              <div className="flex flex-wrap gap-2">
                {['Ceramide NP', 'Squalane', 'Coco-Caprylate/Caprate'].map((ing) => (
                  <span key={ing} className="text-[10px] tracking-[0.08em] uppercase px-3 py-1.5 rounded-full bg-[#2D6A4F]/10 text-[#2D6A4F] font-medium">{ing}</span>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <span className="text-[11px] tracking-[0.15em] uppercase text-[#2A2A2A] font-medium">{t('threeStep.step03.howToUse')}</span>
              <ol className="flex flex-col gap-2 list-decimal list-inside">
                <li className="text-xs text-[#8A8A8A] font-light">{t('threeStep.step03.use1')}</li>
                <li className="text-xs text-[#8A8A8A] font-light">{t('threeStep.step03.use2')}</li>
                <li className="text-xs text-[#8A8A8A] font-light">{t('threeStep.step03.use3')}</li>
                <li className="text-xs text-[#8A8A8A] font-light">{t('threeStep.step03.use4')}</li>
                <li className="text-xs text-[#8A8A8A] font-light">{t('threeStep.step03.use5')}</li>
              </ol>
            </div>

            <Link
              to={prefix + '/products/barrier-seal-cream'}
              className="mt-2 px-7 py-3 bg-[#2D6A4F] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#1E4D3A] transition-colors cursor-pointer w-fit text-center"
            >
              {t('threeStep.step03.cta')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}